import { PublicTemplateConfigurationProps } from '~/components/Templates/components/FlowTemplates/PublicTemplateConfigurationModal';
import { useRootStore } from '~/stores/useRootStore';
import { useState } from 'react';
import { usePublishedTemplate } from '~/components/Templates/components/FlowTemplates/usePublishedTemplate';
import { THUMBNAILS_MODE_PARAM } from '~/common/consts';

export const useGalleryTemplate = ({
    publicConfiguration
}: PublicTemplateConfigurationProps) => {
    const {
        templatesUiStore: { selectedTemplate }
    } = useRootStore();
    const [isGalleryTemplate, setIsGalleryTemplate] = useState(
        publicConfiguration?.is_gallery_template
    );
    const { changeConfiguration, trackEvent } = usePublishedTemplate({
        publicConfiguration
    });

    const toggleGalleryTemplate = async () => {
        trackEvent({
            event: 'gallery template toggle',
            additionalData: {
                toggledTo: !publicConfiguration?.is_gallery_template
            }
        });
        return changeConfiguration({
            configType: 'is_gallery_template',
            state: !publicConfiguration?.is_gallery_template,
            setLocalState: setIsGalleryTemplate
        });
    };

    const generateThumbnails = () => {
        const publicUrl = selectedTemplate.public_configuration?.public_url_cx;
        if (publicUrl) {
            const searchParams = {
                [THUMBNAILS_MODE_PARAM]: 'true'
            };

            const searchParamsString = new URLSearchParams(
                searchParams
            ).toString();
            const link = `${publicUrl}${
                publicUrl.includes('cpu') ? '&' : '?'
            }${searchParamsString}`;

            window.open(link, '_blank');
        }
    };

    return {
        generateThumbnails,
        toggleGalleryTemplate,
        isGalleryTemplate
    };
};
